import { BattleManager } from "./scenes/battle-scene/BattleManager";
import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { AudioManager } from "./AudioManager";
import mexp from "math-expression-evaluator";
import * as Anuto from "../engine/src";
import { BattleScene } from "./scenes/battle-scene/BattleScene";

export class GameManager {

    public static init(): void {

        if (GameVars.currentScene.sys.game.device.os.desktop) {
            GameVars.scaleX = 1;
            GameVars.scaleY = 1;

        } else {

            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            GameVars.currentScene.game.scale.refresh();

            GameVars.aspectRatio = window.innerWidth / window.innerHeight;
            GameVars.contrascaleX = (GameVars.aspectRatio - (4 / 3)) * .2;

            if (window.innerHeight > window.innerWidth) {
                GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (window.innerWidth / window.innerHeight);
                GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);

            } else {
                GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (window.innerWidth / window.innerHeight);
                GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);
            }
        }

        GameManager.readGameData();

        GameVars.firstTimeLobby = true;
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {
                    GameManager.initGameData();
                }

                GameManager.startGame();
            }
        );
    }

    public static initGameData(): void {

        GameVars.gameData = {
            soundMuted: false,
            soundtrackMuted: false,
            upgradesUnlocked: {},
            coins: GameConstants.INITIAL_COINS,
            progression: [],
            levelsInfo: [],
            specialAttacks: [false, false],
            initialTutorial: true,
            buyTutorial: true
        };

        for (let i = 0; i < 5; i++) {
            GameVars.gameData.progression.push({ mapsProgress: [], completed: false });
            for (let j = 0; j < 6; j++) {
                let map = { stars: 0, mapName: "map_" + (j + (i * 6) + 1), unlocked: false };
                GameVars.gameData.progression[i].mapsProgress.push(map);
            }
        }

        let levelInfo = {
            stars: 0,
            lives: 0,
            coins: 0,
            ticks: 0,
            round: 0,
            turrets: [1, 0, 0, 0, 0, 0, 0, 0],
            specials: [true, true]
        };

        for (let i = 0; i < 31; i++) {
            GameVars.gameData.levelsInfo.push(levelInfo);
        }

        GameVars.gameData.progression[0].mapsProgress[0].unlocked = true;

        const turretsKeys = [
            Anuto.GameConstants.TURRET_PEA,
            Anuto.GameConstants.TURRET_MORTAR,
            Anuto.GameConstants.TURRET_SPLAT,
            Anuto.GameConstants.TURRET_BZZT,
            Anuto.GameConstants.TURRET_ROCKETS,
            Anuto.GameConstants.TURRET_MINES,
            Anuto.GameConstants.TURRET_FIRE,
            Anuto.GameConstants.TURRET_TELEPORT];

        for (let i = 0; i < turretsKeys.length; i++) {
            GameVars.gameData.upgradesUnlocked[turretsKeys[i]] = i === 0 ? 1 : 0;
        }
    }

    public static unlockAll(): void {

        GameVars.gameData.progression = [];

        for (let i = 0; i < 5; i++) {
            GameVars.gameData.progression.push({ mapsProgress: [], completed: false });
            for (let j = 0; j < 6; j++) {
                let map = { stars: 3, mapName: "map_" + (j + (i * 6) + 1), unlocked: true };
                GameVars.gameData.progression[i].mapsProgress.push(map);
            }
        }

        const turretsKeys = Object.keys(GameVars.turretsData);

        for (let i = 0; i < turretsKeys.length; i++) {
            GameVars.gameData.upgradesUnlocked[turretsKeys[i]] = 3;
        }

        GameVars.gameData.coins = 1e5;
        GameVars.gameData.specialAttacks = [true, true];
        GameVars.gameData.initialTutorial = false;
        GameVars.gameData.buyTutorial = false;

        GameManager.writeGameData();
    }

    public static setCurrentScene(scene: Phaser.Scene): void {

        if (GameVars.currentScene) {
            GameVars.currentScene.scene.setVisible(false);
        }

        GameVars.currentScene = scene;
    }

    public static onGameAssetsLoaded(): void {
        //@ts-ignore

        window.pp = () => {
            if (BattleScene.currentInstance) {
                BattleScene.currentInstance.showPauseMenu();
            }
            GameVars.paused = true;
        }
        if (typeof window.GameSnacks !== "undefined") {

            window.GameSnacks.game.ready();


            window.GameSnacks.game.onPause(() => {
                GameManager.writeGameData();
                if (BattleScene.currentInstance) {
                    BattleScene.currentInstance.showPauseMenu();
                }
                GameVars.paused = true;
            });

            window.GameSnacks.game.onResume(() => {
                if (BattleScene.currentInstance) {
                    BattleScene.currentInstance.hidePauseMenu();
                }
                GameVars.paused = false;
            });
        }

        GameVars.gameLoaded = true;

        GameVars.enemiesData = GameVars.currentScene.cache.json.get("enemies").enemies;
        GameVars.turretsData = GameVars.currentScene.cache.json.get("turrets").turrets;
        GameVars.modifiers = GameVars.currentScene.cache.json.get("turrets").modifiers;

        GameVars.wavesInfo = GameManager.concatWavesJsons();

        GameManager.generateTurretsAttributes();
        GameManager.generateTurretExtraValues();

        AudioManager.init();

        // GameManager.enterBattleScene("map_1", 1, 1);

        if (GameConstants.LEVEL_EDITION) {
            GameManager.enterLevelsEditorScene();
        } else {
            GameManager.enterLobbyScene();
        }
    }

    public static concatWavesJsons(): any {

        let wave1 = GameVars.currentScene.cache.json.get("waves_1");
        let wave2 = GameVars.currentScene.cache.json.get("waves_2");
        let wave3 = GameVars.currentScene.cache.json.get("waves_3");
        let wave4 = GameVars.currentScene.cache.json.get("waves_4");
        let wave5 = GameVars.currentScene.cache.json.get("waves_5");

        let waveFinal = Object.assign({}, wave1, wave2, wave3, wave4, wave5);

        return waveFinal;
    }

    public static enterLobbyScene(): void {

        GameVars.currentScene.scene.start("LobbyScene");
    }

    public static enterLevelsEditorScene(): void {

        GameVars.currentScene.scene.start("LevelsEditorScene");
    }

    public static enterBattleScene(map?: string, zone?: number, index?: number): void {

        if (map) {
            GameVars.currentMapData = GameManager.generateMapData(map);
            GameVars.currentMapZone = zone;
            GameVars.currentMapCount = index;
        }

        if (!GameVars.currentMapData) {
            GameVars.currentMapData = GameManager.generateMapData("map_1");
        }


        GameVars.currentScene.scene.start("BattleScene");
    }

    public static reset(): void {

        GameManager.enterBattleScene();
    }

    public static buyUpgradeTurret(type: string): void {

        GameVars.gameData.buyTutorial = false;

        GameVars.gameData.coins -= GameVars.turretsData[type].buy[GameVars.gameData.upgradesUnlocked[type]];
        GameVars.gameData.upgradesUnlocked[type]++;

        GameManager.writeGameData();
    }

    public static getTotalStars(): number {

        let stars = 0;
        for (let i = 0; i < GameVars.gameData.progression.length; i++) {
            let zone = GameVars.gameData.progression[i].mapsProgress;
            for (let j = 0; j < zone.length; j++) {
                stars += zone[j].stars;
            }
        }

        return stars;
    }

    public static savePreviousTurrets(): void {

        GameVars.prevTurrets = {
            name: GameVars.currentMapData.name,
            turrets: []
        };

        const turrets = BattleManager.anutoEngine.turrets;

        for (let i = 0; i < turrets.length; i++) {

            const turret = { p: turrets[i].position, type: turrets[i].type, level: turrets[i].level };

            GameVars.prevTurrets.turrets.push(turret);
        }
    }

    public static getDownloadData(zone: number): string {

        let waves = {};

        if (zone === 0) {
            waves["map_0"] = GameVars.wavesInfo["map_0"];
        }

        for (let i = 1; i <= 6; i++) {
            waves["map_" + (i + 6 * zone)] = GameVars.wavesInfo["map_" + (i + 6 * zone)];
        }

        return JSON.stringify(waves);
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    public static generateMapData(name: string): any {

        if (!GameVars.currentScene.cache.tilemap.get(name)) {
            return null;
        }

        let data = GameVars.currentScene.cache.tilemap.get(name).data;

        let height = data.height;
        let width = data.width;

        let layers = data.layers;
        // let tileset = data.tilesets[0];

        let objects: any;


        for (let i = 0; i < layers.length; i++) {
            if (layers[i].name === "objects") {
                objects = layers[i];
            }
        }

        let paths = [];
        let flags = [];

        for (let i = 0; i < objects.objects.length; i++) {
            if (objects.objects[i].type === "path") {
                paths.push(objects.objects[i]);
            } else if (objects.objects[i].type === "flag") {
                flags.push(objects.objects[i]);
            }
        }

        const mapObject: any = {};
        mapObject.size = { r: height, c: width - 2 };
        mapObject.paths = [];
        mapObject.plateaus = [];
        mapObject.waves = {};
        mapObject.name = name;

        // PATHS
        for (let i = 0; i < paths.length; i++) {

            let pathObject = { name: paths[i].name, path: [] };

            let points = [];
            for (let j = 0; j < paths[i].polyline.length; j++) {
                points.push({ r: Math.floor((paths[i].polyline[j].y + paths[i].y) / 64), c: Math.floor((paths[i].polyline[j].x + paths[i].x) / 64) - 1 });
            }

            pathObject.path.push(points[0]);

            for (let j = 1; j < points.length; j++) {

                let c = points[j - 1].c;
                let r = points[j - 1].r;

                while (c !== points[j].c || r !== points[j].r) {

                    if (c < points[j].c) {
                        c++;
                        pathObject.path.push({ r: r, c: c });
                    } else if (c > points[j].c) {
                        c--;
                        pathObject.path.push({ r: r, c: c });
                    }

                    if (r < points[j].r) {
                        r++;
                        pathObject.path.push({ r: r, c: c });
                    } else if (r > points[j].r) {
                        r--;
                        pathObject.path.push({ r: r, c: c });
                    }
                }
            }

            mapObject.paths.push(pathObject);
        }

        // FLAGS 
        for (let i = 0; i < flags.length; i++) {
            mapObject.plateaus.push({ r: Math.floor(flags[i].y / 64), c: Math.floor(flags[i].x / 64) - 1 });
        }

        // WAVES
        mapObject.waves = GameVars.wavesInfo[name];

        return mapObject;
    }

    private static startGame(): void {
        if (typeof window.GameSnacks !== "undefined") {
            window.GameSnacks.game.firstFrameReady();
        }

        GameVars.currentScene.scene.start("PreloadScene");
    }

    private static getGameStorageData(key: string, successCb: Function): void {

        if (typeof window.GameSnacks !== "undefined") {
            let gameDataStr = window.GameSnacks.storage.getItem(key);
            successCb(gameDataStr);
        } else {
            let gameDataStr = localStorage.getItem(key);
            successCb(gameDataStr);
        }
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {
        if (typeof window.GameSnacks !== "undefined") {
            window.GameSnacks.storage.setItem(key, JSON.stringify(value));
        } else {
            localStorage.setItem(key, JSON.stringify(value));
        }
        successCb();
    }

    private static generateTurretsAttributes(): void {

        let keys = Object.keys(GameVars.turretsData);

        for (let i = 0; i < keys.length; i++) {

            let values = GameVars.turretsData[keys[i]].attributes;

            switch (keys[i]) {
                case Anuto.GameConstants.TURRET_PEA:
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_DAMAGE, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].first, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].second, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RELOAD, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].first, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].second, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RANGE, values[Anuto.GameConstants.ATTRIBUTE_RANGE].first, values[Anuto.GameConstants.ATTRIBUTE_RANGE].second, values[Anuto.GameConstants.ATTRIBUTE_RANGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].first, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].second, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].func, 3);
                    break;
                case Anuto.GameConstants.TURRET_MORTAR:
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_DAMAGE, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].first, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].second, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RELOAD, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].first, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].second, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RANGE, values[Anuto.GameConstants.ATTRIBUTE_RANGE].first, values[Anuto.GameConstants.ATTRIBUTE_RANGE].second, values[Anuto.GameConstants.ATTRIBUTE_RANGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE, values[Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE].first, values[Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE].second, values[Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].first, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].second, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].func, 3);
                    break;
                case Anuto.GameConstants.TURRET_SPLAT:
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_INTENSITY, values[Anuto.GameConstants.ATTRIBUTE_INTENSITY].first, values[Anuto.GameConstants.ATTRIBUTE_INTENSITY].second, values[Anuto.GameConstants.ATTRIBUTE_INTENSITY].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_DURATION, values[Anuto.GameConstants.ATTRIBUTE_DURATION].first, values[Anuto.GameConstants.ATTRIBUTE_DURATION].second, values[Anuto.GameConstants.ATTRIBUTE_DURATION].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RELOAD, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].first, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].second, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RANGE, values[Anuto.GameConstants.ATTRIBUTE_RANGE].first, values[Anuto.GameConstants.ATTRIBUTE_RANGE].second, values[Anuto.GameConstants.ATTRIBUTE_RANGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].first, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].second, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].func, 3);
                    break;
                case Anuto.GameConstants.TURRET_BZZT:
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_DAMAGE, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].first, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].second, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RELOAD, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].first, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].second, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RANGE, values[Anuto.GameConstants.ATTRIBUTE_RANGE].first, values[Anuto.GameConstants.ATTRIBUTE_RANGE].second, values[Anuto.GameConstants.ATTRIBUTE_RANGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].first, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].second, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].func, 3);
                    break;
                case Anuto.GameConstants.TURRET_ROCKETS:
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_DAMAGE, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].first, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].second, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RELOAD, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].first, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].second, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RANGE, values[Anuto.GameConstants.ATTRIBUTE_RANGE].first, values[Anuto.GameConstants.ATTRIBUTE_RANGE].second, values[Anuto.GameConstants.ATTRIBUTE_RANGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE, values[Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE].first, values[Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE].second, values[Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].first, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].second, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].func, 3);
                    break;
                case Anuto.GameConstants.TURRET_MINES:
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_DAMAGE, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].first, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].second, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RELOAD, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].first, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].second, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RANGE, values[Anuto.GameConstants.ATTRIBUTE_RANGE].first, values[Anuto.GameConstants.ATTRIBUTE_RANGE].second, values[Anuto.GameConstants.ATTRIBUTE_RANGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE, values[Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE].first, values[Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE].second, values[Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_MAX_NUM_MINES, values[Anuto.GameConstants.ATTRIBUTE_MAX_NUM_MINES].first, values[Anuto.GameConstants.ATTRIBUTE_MAX_NUM_MINES].second, values[Anuto.GameConstants.ATTRIBUTE_MAX_NUM_MINES].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].first, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].second, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].func, 3);
                    break;
                case Anuto.GameConstants.TURRET_FIRE:
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_DAMAGE, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].first, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].second, values[Anuto.GameConstants.ATTRIBUTE_DAMAGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RELOAD, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].first, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].second, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RANGE, values[Anuto.GameConstants.ATTRIBUTE_RANGE].first, values[Anuto.GameConstants.ATTRIBUTE_RANGE].second, values[Anuto.GameConstants.ATTRIBUTE_RANGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].first, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].second, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].func, 3);
                    break;
                case Anuto.GameConstants.TURRET_TELEPORT:
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_TELEPORT_DISTANCE, values[Anuto.GameConstants.ATTRIBUTE_TELEPORT_DISTANCE].first, values[Anuto.GameConstants.ATTRIBUTE_TELEPORT_DISTANCE].second, values[Anuto.GameConstants.ATTRIBUTE_TELEPORT_DISTANCE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RELOAD, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].first, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].second, values[Anuto.GameConstants.ATTRIBUTE_RELOAD].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_RANGE, values[Anuto.GameConstants.ATTRIBUTE_RANGE].first, values[Anuto.GameConstants.ATTRIBUTE_RANGE].second, values[Anuto.GameConstants.ATTRIBUTE_RANGE].func, 3);
                    GameManager.setAttributes(keys[i], Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].first, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].second, values[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].func, 3);
                    break;
                default:
                    break;
            }
        }
    }

    private static setAttributes(turret: string, attribute: string, pprev: number, prev: number, func: string, length: number): void {

        let res = [];
        for (let i = 0; i < length; i++) {
            if (i === 0) {
                res[i] = pprev;
            } else if (i === 1) {
                res[i] = prev;
            } else {
                pprev = res[i - 2];
                prev = res[i - 1];
                let funcAux = func.replace(/i/g, i.toString());
                funcAux = funcAux.replace(/pprev/g, pprev.toString());
                funcAux = funcAux.replace(/prev/g, prev.toString());
                res[i] = Math.round(mexp.eval(funcAux) * 100) / 100;
            }
        }

        GameVars.turretsData[turret].attributes[attribute] = res;
    }

    private static generateTurretExtraValues(): void {

        let keys = Object.keys(GameVars.turretsData);

        for (let i = 0; i < keys.length; i++) {
            let turret = GameVars.turretsData[keys[i]];
            turret.extraAttributes = {};
            turret.extraAttributes.DPS = [];
            turret.extraAttributes.coefficient = [];
            for (let j = 0; j < turret.attributes[Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE].length; j++) {

                let lvl = j + 1;
                let damage = turret.attributes[Anuto.GameConstants.ATTRIBUTE_DAMAGE] ? turret.attributes[Anuto.GameConstants.ATTRIBUTE_DAMAGE][j] : 0;
                let reload = turret.attributes[Anuto.GameConstants.ATTRIBUTE_RELOAD][j] || (1 / 10);
                let range = turret.attributes[Anuto.GameConstants.ATTRIBUTE_RANGE][j];
                let explosionRange = turret.attributes[Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE] ? turret.attributes[Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE][j] : 0;

                let dps = Math.round(damage / reload);
                turret.extraAttributes.DPS[j] = dps;

                let maxDPS = j === 0 ? 1 : j * 4;

                // FORMULA: (dps / (100 * lvl * lvl)) * 50 + (range / 5) * 30 + (explosionRange / 5) * 15 + isBzztTurret * 5
                turret.extraAttributes.coefficient[j] = Math.round((dps / (100 * maxDPS)) * 50 + (range / 5) * 30 + (explosionRange / 5) * 15) + (keys[i] === Anuto.GameConstants.TURRET_BZZT ? 5 : 0);

                if (keys[i] === Anuto.GameConstants.TURRET_SPLAT || keys[i] === Anuto.GameConstants.TURRET_TELEPORT) {
                    turret.extraAttributes.coefficient[j] = 0;
                }
            }
        }
    }
}
